module.exports = "/_next/static/images/Clock-8061254fd1e3cb0d5791122f396acb35.png";